import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'

const LineIcon = (props) => {
    return (
        <Icon viewBox="0 0 15 24" {...props}>
            <line
                x1="14.4271"
                y1="0.259973"
                x2="0.4271"
                y2="23.26"
                stroke="currentColor"
                strokeWidth={remCalc(1)}
                fill="none"
            />
        </Icon>
    )
}

LineIcon.propTypes = {
    color: PropTypes.string,
}

export default LineIcon
